import { Typography } from '@mui/material';
import AssetsConnected from './AssetsConnected';
import NetworkStatus from './NetworkStatus';
import NetworkStrength from './NetworkStrength';
import MeshGraph from './MeshGraph';
import { type MeshStatusNode, type MeshData } from '../NetworkHealth';
import MeshStatus from './MeshStatus';
import NetworkHealthCard from './NetworkHealthCard';
import { useTranslation } from 'react-i18next';

interface NetworkMeshProps {
  nodeCount: number;
  count: number;
  networkStrength: string;
  meshData: MeshData;
  meshStatusNodes: MeshStatusNode[];
}
export function NetworkMesh({
  nodeCount,
  count,
  networkStrength,
  meshData,
  meshStatusNodes,
}: NetworkMeshProps) {
  const { t } = useTranslation();
  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
      }}
    >
      <div
        style={{
          width: '100%',
          height: '100%',
          display: 'grid',
          gridTemplateColumns: '1fr 1fr 1fr',
          gap: '16px',
        }}
      >
        <NetworkStatus
          status={nodeCount === 0 ? 'Disconnected' : 'Connected'}
        />
        <AssetsConnected count={count} />
        <NetworkStrength status={networkStrength} />
      </div>
      <div
        style={{
          width: '100%',
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gap: '16px',
        }}
      >
        <div style={{ width: '100%', height: '100%', gridColumn: 'span 2' }}>
          <NetworkHealthCard>
            <Typography variant="h6" gutterBottom>
              {t('network_configuration')}
            </Typography>
            <MeshGraph apiResponse={meshData} />
          </NetworkHealthCard>
        </div>
        <div style={{ width: '100%', height: '100%' }}>
          <MeshStatus nodes={meshStatusNodes} />
        </div>
      </div>
    </div>
  );
}

export default NetworkMesh;
